var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-input", {
        attrs: { value: _vm.value1 },
        on: {
          focus: function ($event) {
            return _vm.inputFocus()
          },
        },
      }),
      _c(
        "My-dialog",
        {
          attrs: { options: _vm.dialogOption },
          on: { beforeClose: _vm.beforeClose },
        },
        [
          _c("My-table", {
            attrs: {
              options: _vm.tableOption.options,
              data: _vm.data,
              pagination: _vm.tableOption.pagination,
              searchData: _vm.tableOption.tableSearch,
            },
            on: {
              callback: _vm.callback,
              "update:searchData": function ($event) {
                return _vm.$set(_vm.tableOption, "tableSearch", $event)
              },
              "update:search-data": function ($event) {
                return _vm.$set(_vm.tableOption, "tableSearch", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }